// extracted by mini-css-extract-plugin
export default {"sectionIntroductionText":"SectionIntroductionText_sectionIntroductionText__hmGPc"};